<template>
    <div class="container footer-section">

        <div class="row row-cols-4 justify-content-between">
            <div class="col">
                <RouterLink to="/survaylist" class="btn  d-flex flex-md-row  flex-column justify-content-md-center align-items-center justify-content-start w-100  home-link">
                    <span class="fa fa-list icon"></span>
                    <span class="text">اندیشه کاوی ها</span>
                </RouterLink>
            </div>
            <div class="col">
                <RouterLink to="/Dependentlist" class="btn d-flex flex-md-row  flex-column justify-content-md-center align-items-center  justify-content-start  w-100  home-link">
                    <span class="fa fa-list icon"></span>
                    <span class="text">اندیشه کاوی وابسته</span>
                </RouterLink>

            </div>
            <div class="col">
                <RouterLink to="/giftlist" class="btn  d-flex flex-md-row  flex-column justify-content-md-center align-items-center  justify-content-start w-100  home-link">
                    <span class="fa fa-money-bill icon"></span>
                    <span class="text">حقوق و مزایا</span>
                </RouterLink>
            </div>
            <div class="col">
                <RouterLink to="/usergiftlist" class="btn   d-flex flex-md-row  flex-column justify-content-md-center align-items-center justify-content-start w-100  home-link">
                    <span class="fa fa-money-bill-wave icon"></span>
                    <span class="text">حقوق دریافتی</span>
                </RouterLink>
            </div>

        </div>


    </div>
</template>


<style>
.footer-section {
    border-radius: 5px;
    margin-bottom: 30px;

}

.home-link {
    border: 1px solid #e7e7e7;
    box-shadow: 0 0 10px #ddd;
    font-size: 14px;
    padding-top: 15px;
    padding-bottom: 15px;
    gap:10px;
}

.router-link-active {

    color: #ffffff !important;
    background-color: #4e73df;

}

@media (max-width:768px) {
    .footer-section {
        border-radius: 20px;
        border-top: 1px solid #f3f3f3;
        padding: 15px 0;
        box-shadow: 0 0 10px #ddd;
        margin: 0;



    }

    .footer-section .col {
        padding: 0 1px
    }

    .home-link {
        font-size: 8px;
        padding: 6px 1px;
        border: 0;
        box-shadow: none;
        transition: background-color 1s all ease;
        gap: 5px;

    }

    .router-link-active {

        color: #4e73df !important;
        background-color: #fff;

    }


    .home-link .icon {
        font-size: 14px;

    }

    .btn:focus,
    .btn.focus {

        box-shadow: none !important;
    }
}
</style>